import { registerSW } from 'virtual:pwa-register'

type UpdateListener = (state: SWUpdateState) => void

interface SWUpdateState {
  updateAvailable: boolean
  offlineReady: boolean
}

let state: SWUpdateState = { updateAvailable: false, offlineReady: false }
let updateSWFn: ((reloadPage?: boolean) => Promise<void>) | null = null
let initialized = false
const listeners = new Set<UpdateListener>()

function notify() {
  for (const listener of listeners) {
    listener(state)
  }
}

export function initSWRegistration(): void {
  if (initialized) return
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return
  initialized = true

  updateSWFn = registerSW({
    immediate: true,
    onNeedRefresh() {
      state = { ...state, updateAvailable: true }
      notify()
    },
    onOfflineReady() {
      state = { ...state, offlineReady: true }
      notify()
    },
  })

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      void checkForUpdate()
    }
  })
}

export function subscribeToUpdates(listener: UpdateListener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function getUpdateState(): SWUpdateState {
  return state
}

export async function applyUpdate(): Promise<void> {
  if (updateSWFn) {
    await updateSWFn(true)
  }
}

export function dismissUpdate(): void {
  state = { ...state, updateAvailable: false }
  notify()
}

async function checkForUpdate(): Promise<void> {
  const registration = await navigator.serviceWorker?.getRegistration()
  if (registration) {
    await registration.update()
  }
}
